/**
 *  update by tannc 2018年12月24日20:33:50
 */

import { SUBJECT_SAVE_API,SUBJECT_ENABLE_API,SUBJECT_API } from '../resource/index';
import axios from '../config/axios.config';
export default {

   async save(params) {
      return await axios.save(SUBJECT_SAVE_API,{},params);
   },
  async enableOrDisable(params) {
    return await axios.update(SUBJECT_ENABLE_API,params,{});
  },
  async fetchData(id) {
    return await axios.get(SUBJECT_API,{id:id});
  }


}



// WEBPACK FOOTER //
// ./src/service/classService.js